import { MainLoader, ResourceLoader, useScopedSelector } from 'ia-react-core';
import React, { FC, useCallback } from 'react';
import { Form, redirectTo } from 'omni-package-react-core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getProfileApiRoot } from '../../../utils/getProfileApiRoot';
import UsernameSection from './UsernameSection';
import { UsernameFormPageState } from '../../../interfaces/UsernameFormPageState';
import Constants from '../../../Constants';
import { AccountResourceInfo } from '../../../components/AccountResource/AccountResource';

export interface UsernameFormProps { }

const UsernameForm: FC<UsernameFormProps> = () => {
  const { t } = useTranslation('UsernameFormPage');
  const formState = useScopedSelector((state: UsernameFormPageState) => state);
  const navigate = useNavigate();

  const handleSubmit = useCallback(() => {
    redirectTo(
      Constants.UsernameConfirmationPath,
      navigate,
      { data: { newUsername: formState?.usernameFormValues?.username } },
    );
  }, [formState?.usernameFormValues?.username, navigate]);

  const buildPayload = (values: unknown) => {
    const inputsMap = new Map(Object.entries(values));
    return (
      {
        username: inputsMap.get('username'),
        password: inputsMap.get('currentPassword'),
      });
  };

  const fields: { [name: string]: string } = {};
  fields['accountModel.Username'] = 'username';
  fields['accountModel.Password'] = 'currentPassword';
  fields.username = 'username';
  fields.password = 'currentPassword';

  return (
    <ResourceLoader
      resourceSrc={AccountResourceInfo.name}
      inlineErrorMessage={false}
      buttonAlign="left"
      CustomLoader={MainLoader}
    >
      <Form
        name="usernameForm"
        onSuccess={handleSubmit}
        dataSrc="usernameFormValues"
        dataDst="newUsernameFormValues"
        url={`${getProfileApiRoot()}/account`}
        createMethod="PATCH"
        transformRequest={(values: unknown) => buildPayload(values)}
        controlErrorMapping={fields}
        infoMessageText={t('informationsLabel')}
      >
        <UsernameSection />
      </Form>
    </ResourceLoader>
  );
};

export default UsernameForm;
